import { render } from "./description-input.vue?vue&type=template&id=e5933440"
import script from "./description-input.vue?vue&type=script&lang=js"
export * from "./description-input.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__